import React, { useContext } from 'react';

import { UserContext } from 'components/shared/context/UserContextProvider';

interface IsOwnerProps {
  children?: React.ReactNode;
}

const IsOwner: React.FC<IsOwnerProps> = ({ children }) => {
  const { userState } = useContext(UserContext);

  return <>{userState.isOwner ? children : null}</>;
};

export default IsOwner;
